import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'tog-tooltip-button',
  templateUrl: './tooltip-button.component.html',
  styleUrls: ['./tooltip-button.component.scss']
})
export class TooltipButtonComponent implements OnInit {
  dropdown: HTMLElement;
  showTooltip: boolean = false;
  fixedTooltip: boolean = false;
  @Input() caption: string = '';

  // for when we're doing just the tooltips
  @Input() scrollParentClassName: string = '';
  tooltipMarginOriginalValue = 5;

  @ViewChild('tooltip') tooltip: ElementRef;

  constructor(private _el: ElementRef) { }

  ngOnInit() {
    let els = this._el.nativeElement.getElementsByTagName('tog-tooltip-button-dropdown');
    if (els.length) this.dropdown = els[0];
  }

  openDropdown() {
    this.fixedTooltip = this._el.nativeElement.classList.contains('force-fixed');

    if (this.dropdown) this.dropdown.classList.add('active');
    if (this.fixedTooltip) {
      let scrollParent = document.getElementsByClassName(this.scrollParentClassName)[0];
      this.tooltip.nativeElement.style.marginTop = this.tooltipMarginOriginalValue - scrollParent.scrollTop + "px";
    }
  }

  hideDropdown() {
    if (this.dropdown) this.dropdown.classList.remove('active');
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/tooltip-button/tooltip-button.component.ts